import React, { useCallback, useState, createContext, useEffect } from "react"
import { LocalStorageService } from "../services/LocalStorageService"
import { FEATURE_BRANDS_ARRAY } from "../theme/data"

export const SearchContext = createContext({
  profiles: [],
  brands: [],
  models: [],
  addToSearch: (e: string, value: any) => {},
})

const SearchProvider = ({ children }) => {
  const [profiles, setProfiles] = useState([])
  const [brands, setBrands] = useState([])
  const [models, setModels] = useState([])

  const addToSearch = useCallback(
    (name, value) => {
      if (name === "profiles" && !profiles.map(el => el.id).includes(value.id)) {
        let arr = [...profiles]
        arr.unshift(value)
        arr = arr.slice(0, 3)
        setProfiles(arr)
        LocalStorageService.setObject("searchProfiles", JSON.stringify(arr))
      }
      if (name === "brands" && !brands.includes(value)) {
        let arr = [...brands]
        arr.unshift(value)
        arr = arr.slice(0, 3)
        setBrands(arr)
        LocalStorageService.setObject("searchBrands", JSON.stringify(arr))
      }
      if (name === "models" && !models.includes(value)) {
        let arr = [...models]
        arr.unshift(value)
        arr = arr.slice(0, 3)
        setModels(arr)
        LocalStorageService.setObject("searchModels", JSON.stringify(arr))
      }
    },
    [profiles, brands, models],
  )

  useEffect(() => {
    setProfiles(JSON.parse(LocalStorageService.getObject("searchProfiles") || "[]"))
    setBrands(JSON.parse(LocalStorageService.getObject("searchBrands") || '["audi","bmw","kia"]'))
    setModels(JSON.parse(LocalStorageService.getObject("searchModels") || "[]"))
  }, [])

  const getBrands = brands => {
    const arr = brands
    if (arr.length < 3) {
      const l = 3 - arr.length
      for (var i = 0; i < l; i++) {
        arr.push(FEATURE_BRANDS_ARRAY[i])
      }
    }

    return arr
  }

  return (
    <SearchContext.Provider
      value={{
        profiles,
        brands: getBrands(brands),
        models,
        addToSearch,
      }}
    >
      {children}
    </SearchContext.Provider>
  )
}

export default SearchProvider
